import api from '@/lib/api';

export interface TrackEvent {
  code: string;
  name: string;
  message?: string | null;
  timestamp: string;
  location?: string | null;
}

export interface Shipment {
  trackingNumber: string;
  orderNumber?: string;
  carrier: string;
  currentPhase: string;
  estimatedDelivery?: string | null;
  shipDate?: string | null;
  deliveredAt?: string | null;
  timeline: TrackEvent[];
  recipient?: { name?: string; zip?: string; city?: string; country?: string };
}

export interface TrackResult {
  found: boolean;
  shipments: Shipment[];
}

const trackingService = {
  async lookup(p: { email?: string; order?: string; trackingNumber?: string; carrier?: string }): Promise<TrackResult> {
    const { data } = await api.get('/tracking/lookup', { params: p });
    return data?.data || { found: false, shipments: [] };
  },
};

export default trackingService;
